import React, { useEffect } from 'react';
import useStore from '../../store/useStore';
import AgentSelection from '../agents/AgentSelection';
import ChatArea from '../chat/ChatArea';

const MainContent = () => {
  const { selectedAgent, createNewChat } = useStore();

  // Crear automáticamente un nuevo chat cuando se selecciona un agente
  useEffect(() => {
    if (selectedAgent) {
      createNewChat(selectedAgent);
    }
  }, [selectedAgent, createNewChat]);

  return (
    <div className="flex-1 h-full overflow-auto">
      {!selectedAgent ? (
        // Si no hay agente seleccionado, mostrar la pantalla de selección
        <AgentSelection />
      ) : (
        // Si hay un agente seleccionado, mostrar directamente el área de chat
        <ChatArea />
      )}
    </div>
  );
};

export default MainContent;
